import { useEffect, useState } from "react";
import { useSetAtom } from "jotai";
import { ClientStateAtom } from "../../../store";
import { checkToken, login } from "../../../api";
import { useNavigate } from "react-router";
import { useUser } from "../../../hooks/useUser";
import { LoginController } from "../types";
import { toast } from "sonner";
// import { useInitialise } from "@/hooks/useInitialise";

export const useLoginController = (): LoginController => {
  const [email, setEmail] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);
  const [formEmailError, setFormEmailError] = useState<string | undefined>();
  const [formPasswordError, setFormPasswordError] = useState<
    string | undefined
  >();
  const [errorMessage, setErrorMessage] = useState<string | undefined>();
  const setClientData = useSetAtom(ClientStateAtom);

  const user = useUser();
  const navigate = useNavigate();
  // const initialiseHook = useInitialise();
  const handleLoginSuccess = (res: any) => {
    // set the client key

    setClientData({
      clientId: res.user.clientId,
      clientKey: res.user.clientKey,
    });

    localStorage.setItem("clientId", res.user.clientId);
    localStorage.setItem("clientKey", res.user.clientKey);

    user.setLoginSettings(email, res.user.gridTheme, res.token);
    //initialiseHook.initialise();

    setTimeout(() => {
      navigate("/app/dashboard");
      setLoading(false);
    }, 200);
  };

  const handleLoginError = (res: any) => {
    if (res.errors) {
      res.errors.forEach((e: any) => {
        const errorMsg = e.msg;
        if (e.path === "email") {
          setFormEmailError(errorMsg);
        } else if (e.path === "password") {
          setFormPasswordError(errorMsg);
        }
        toast.error("Error", { description: errorMsg });
      });
    } else {
      setErrorMessage(res.message);
      toast.error("Error", { description: res.message });
    }
    setLoading(false);
    user.logUserOut();
  };

  const performLogin = async () => {
    try {
      setLoading(true);
      user.setLoading(true);
      setFormEmailError(undefined);
      setFormPasswordError(undefined);

      const res = await login(email, password);

      if (res.success) {
        handleLoginSuccess(res);
      } else {
        handleLoginError(res);
      }
    } catch (error) {
      console.error("Login failed:", error);
      user.logUserOut();
      setLoading(false);
      toast.error("Error", {
        description: "Failed to login. Please try again.",
      });
    }
  };

  const checkIfAlreadyLoggedIn = async () => {
    try {
      const data = await checkToken();
      if (data.success) {
        navigate("/app/dashboard");
      }
    } catch (error) {
      console.error("Token check failed:", error);
    }
  };

  useEffect(() => {
    checkIfAlreadyLoggedIn();
  }, []);

  return {
    email,
    setEmail,
    password,
    loading,
    setPassword,
    errorMessage,
    login: performLogin,
    formEmailError,
    formPasswordError,
  } as LoginController;
};
